import { useCallback, useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { useBusinessStore } from '../store/useBusinessStore';
import { useAuthStore } from '../store/useAuthStore';
import { supabase } from '../supabaseClient';
import { defaultPeriod } from '../utils/ads';

const DEMO_BUSINESS_IDS = ['9001', '9002', '9003'];

export const isMissingAds = (error) =>
  ['PGRST202', '42883', '42P01', 'PGRST205'].includes(error?.code) || /ads_summary|ads_daily|ads_connections/i.test(error?.message || '');

// Resumen de anuncios en Meta del negocio (últimos 30 días y mes en curso contra el tope). Solo lectura: las cifras las llena n8n.
export const useAds = () => {
  const { activeBusinessId } = useBusinessStore();
  const { userRole } = useAuthStore();
  const isReadOnlyDemo = DEMO_BUSINESS_IDS.includes(String(activeBusinessId)) && userRole !== 'master';
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(true);
  const [missing, setMissing] = useState(false);

  const load = useCallback(async () => {
    if (!activeBusinessId || isReadOnlyDemo) { setLoading(false); return; }
    const { from, to } = defaultPeriod();
    const { data, error } = await supabase.rpc('ads_summary', { p_business: String(activeBusinessId), p_from: from, p_to: to });
    if (error) {
      const gone = isMissingAds(error);
      setMissing(gone);
      if (!gone) toast.error(error.code === '42501' ? 'No tienes permiso sobre este negocio (solo el dueño o un administrador).' : 'No se pudieron leer los anuncios.');
      setSummary(null);
    } else {
      setMissing(false);
      setSummary(data || null);
    }
    setLoading(false);
  }, [activeBusinessId, isReadOnlyDemo]);

  useEffect(() => { load(); }, [load]);

  return { summary, loading, missing, isReadOnlyDemo, reload: load };
};
